import React from "react";

import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { useFieldArray, useFormContext } from "react-hook-form";

import { Button } from "src/base-components/Button";
import {
  buildFilterCondition,
  DEFAULT_JUNCTION,
  MAX_FILTER_GROUPS,
} from "src/base-components/FilterPopover/constants";
import { FilterGroup } from "src/base-components/FilterPopover/FilterGroup";
import {
  FilterConfig,
  FilterFormData,
  Junction,
} from "src/base-components/FilterPopover/types";

export const FilterGroups: React.FC<FilterConfig> = ({
  fields,
  sections,
  valueRenderers,
  operatorOptions,
  fieldOverrides,
  maxGroups = MAX_FILTER_GROUPS,
  maxConditionsPerGroup,
  allowedJunctions,
}) => {
  const form = useFormContext<FilterFormData>();
  const {
    fields: groups,
    append,
    remove,
  } = useFieldArray<FilterFormData>({
    name: "filter_condition.conditions",
  });

  const handleAddGroup = () => {
    const currentJunction: Junction =
      groups.length > 1
        ? (form.getValues(
            "filter_condition.conditions.1.junction",
          ) as Junction) || DEFAULT_JUNCTION
        : DEFAULT_JUNCTION;

    append({
      junction: currentJunction,
      conditions: [buildFilterCondition(currentJunction)],
    });
  };

  return (
    <div className="flex flex-col gap-y-3">
      {groups.map((group, index) => (
        <FilterGroup
          key={group.id}
          allowedJunctions={allowedJunctions}
          fieldOverrides={fieldOverrides}
          fields={fields}
          flat={maxGroups === 1}
          groupIndex={index}
          maxConditionsPerGroup={maxConditionsPerGroup}
          mode={index === 0 ? "where" : "junction"}
          operatorOptions={operatorOptions}
          sections={sections}
          valueRenderers={valueRenderers}
          onRemove={groups.length > 1 ? () => remove(index) : undefined}
        />
      ))}
      {maxGroups > 1 && (
        <div>
          <Button
            dataLoc="add-filter-group"
            disabled={groups.length >= maxGroups}
            iconLeft={faPlus}
            size="sm"
            variant="secondary"
            onClick={handleAddGroup}
          >
            Add filter group
          </Button>
        </div>
      )}
    </div>
  );
};
